export default __webpack_public_path__ + "static/media/ayushi.d86e310e.jpg";